import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

/**
 * Non-blocking warning (e.g. saved data but a side effect like email failed).
 */
const WarningMessage = ({ message }) => {
    const messageLines = message.split('\n');

    return (
        <div autoFocus className="warning-message-container">
            {messageLines.map((line) => (
                <p key={uuidv4()} className="warning-message-text">
                    {line}
                </p>
            ))}
        </div>
    );
};

WarningMessage.propTypes = {
    message: PropTypes.string.isRequired
};

export default WarningMessage;
